module.exports = __webpack_public_path__ + "img/C.d41664c1.jpg";